"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateWindowCustomComponent = void 0;
var metrics_engine_1 = require("@tableau/metrics-engine");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var utils_1 = require("../../../utils");
var configurationStyles_1 = require("../configurationStyles");
var DateWindowRelativeDateComponent_1 = require("./DateWindowRelativeDateComponent");
var DateWindowStartDateComponent_1 = require("./DateWindowStartDateComponent");
var relativeWindowTestId = 'date-window-relative-units';
var startDateTestId = 'date-window-calendar-picker';
var RELATIVE_WINDOW_INDEX = 0;
var CUSTOM_START_DATE_INDEX = 1;
var DateWindowCustomComponent = function (props) {
    var _a = React.useState(indexForSelectedWindow(props.selectedDateWindow)), checkedIndex = _a[0], setCheckedIndex = _a[1];
    var buttonList = [
        {
            label: (React.createElement(React.Fragment, null,
                Localize_1.Messages.RelativeDate({ granularity: (0, utils_1.dateTruncToString)(props.dateTrunc) }),
                React.createElement("br", null),
                checkedIndex === RELATIVE_WINDOW_INDEX && (React.createElement(DateWindowRelativeDateComponent_1.DateWindowRelativeDateComponent, { testId: relativeWindowTestId, dateTrunc: props.dateTrunc, onDateWindowChange: props.onChange, selectedDateWindow: props.selectedDateWindow, validationCounter: props.validationCounter, disabled: props.disabled })))),
            testId: relativeWindowTestId,
            value: relativeWindowTestId,
            disabled: props.disabled,
        },
        {
            label: (React.createElement(React.Fragment, null,
                Localize_1.Messages.CustomStartDate(),
                checkedIndex === CUSTOM_START_DATE_INDEX && (React.createElement(DateWindowStartDateComponent_1.DateWindowStartDateComponent, { testId: startDateTestId, dateTrunc: props.dateTrunc, data: props.data, onDateWindowChange: props.onChange, selectedDateWindow: props.selectedDateWindow, disabled: props.disabled })))),
            testId: startDateTestId,
            value: startDateTestId,
            disabled: props.disabled,
        },
    ];
    var handleChange = function (value, newCheckedIndex) {
        setCheckedIndex(newCheckedIndex);
    };
    var color = props.disabled ? metrics_engine_1.MetricsDisabled : metrics_engine_1.MetricsGrey;
    return (React.createElement("div", { "data-tb-test-id": "date-window-custom-wrapper" },
        React.createElement(widgets_1.RadioButtonWithLabelGroupWidget, __assign({}, {
            className: configurationStyles_1.customDateWindow,
            buttonList: buttonList,
            checkedIndex: checkedIndex,
            handleChange: handleChange,
            label: React.createElement("b", { style: { color: color } }, Localize_1.Messages.CustomRange()),
            layout: widgets_1.RadioLayoutType.Veritical,
            testId: props.testId,
            removeLeftMargin: true,
            disabled: props.disabled,
        }))));
};
exports.DateWindowCustomComponent = DateWindowCustomComponent;
var indexForSelectedWindow = function (window) {
    if ((window === null || window === void 0 ? void 0 : window.type) === metrics_engine_1.DateWindowTypes.DEFINED_START) {
        return CUSTOM_START_DATE_INDEX;
    }
    return RELATIVE_WINDOW_INDEX;
};
//# sourceMappingURL=DateWindowCustomComponent.js.map